import { apiPut, apiPost, apiDelete, apiGet } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel, systemValueOptionText } from '../../generic/systemValues/systemValueLabel'

const ReasonType = () => {
  const { t_ } = useSmartTranslation()
  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      charLimit: 60,
      mandatory: true,
      unique: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Name'),
      field: 'name',
      render: (row) => systemValueLabel(t_, 'reason_type', row),
      renderOnlyInReadMode: true,
      charLimit: 80,
      mandatory: true,
      unique: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
      render: (row) => systemValueDescription(t_, 'reason_type', row),
      renderOnlyInReadMode: true
    },
    {
      name: t_('FO Status type'),
      field: 'foStatusType.name',
      render: (row) => systemValueLabel(t_, 'fabrication_order_status_type', row.foStatusType),
      renderOnlyInReadMode: true,
      filterByLabel: { options: (items) => items.map((item) => ({ value: item.name, label: systemValueLabel(t_, 'fabrication_order_status_type', item) })) },
      mandatory: true,
      type: 'smartSelect',
      readOnly: (row) => {
        return row.systemDefault
      },
      edit: {
        source: async () => {
          return await apiGet('fabricationOrderStatusTypeBasicWithoutWaitingNorActive')
        },
        id: 'id',
        field: 'name',
        optionLabel: (name, items) => systemValueOptionText(t_, 'fabrication_order_status_type', items, name)
      }
    }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => apiPost('reasonType', row)
    },
    edit: {
      fetchFunction: (row) => apiPut('reasonType', row)
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('reasonType/' + rows[0].id)
        } else {
          return apiDelete('reasonTypeMulti', rows)
        }
      },
      visibilityButton: (row) => {
        return !row.systemDefault
      }
    }
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='reasonType'
      columns={columns}
      title={t_('Reason types')}
      dataFetch='reasonTypes'
      actions={actions}
      pageable
      multipleSelection
    />
  )
}

export default ReasonType
